import { WebGLRenderer as l, Scene as p, PerspectiveCamera as h, HemisphereLight as m } from "three";
import { OrbitControls as g } from "three-stdlib";
function E() {
  const t = new l({ antialias: !0 });
  t.setClearColor(11119017, 1), t.setSize(window.innerWidth, window.innerHeight);
  const i = new p(), n = new h(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    1e3
  );
  n.position.set(0, 10, -18);
  const e = new g(n, t.domElement);
  e.enableDamping = !1, e.minDistance = 0.1, e.maxDistance = 300, e.target.set(0, 0, 0), e.target.set(0, 0, 0), e.update();
  const r = new m(16777215, 136);
  r.position.set(-1, 1.5, 1), i.add(r);
  const o = new m(16777215, 8912896, 0.5);
  o.position.set(-1, -1.5, -1), i.add(o);
  const s = () => {
    var w;
    const a = (w = t.domElement.parentElement) == null ? void 0 : w.parentElement;
    if (!a)
      return;
    const { clientWidth: c, clientHeight: d } = a;
    n.aspect = c / d, n.updateProjectionMatrix(), t.setSize(c, d);
  };
  return window.addEventListener("resize", s), { scene: i, camera: n, renderer: t, orbit: e, resize: s };
}
export {
  E as createStage
};
//# sourceMappingURL=index5.js.map
